import { render, staticRenderFns } from "./EditAssets.vue?vue&type=template&id=160df1a6"
import script from "./EditAssets.vue?vue&type=script&lang=js"
export * from "./EditAssets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports